module.exports = __webpack_public_path__ + "img/coins.5e98fd7f.png";